"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsGeoJsonGeofenceCoordinates = void 0;
const class_validator_1 = require("class-validator");
const CoordinatesPair_1 = require("../models/CoordinatesPair");
let IsGeoJsonGeofenceCoordinates = class IsGeoJsonGeofenceCoordinates {
    validate(value) {
        if (!Array.isArray(value)) {
            return false;
        }
        if (value.length !== 1) {
            return false;
        }
        const coordinatesCollection = value[0];
        // Polygon is created from at least 4 coordinate pairs
        if (!Array.isArray(coordinatesCollection) ||
            coordinatesCollection.length <= 3) {
            return false;
        }
        const openingCoordinates = coordinatesCollection[0];
        const closingCoordinates = coordinatesCollection[coordinatesCollection.length - 1];
        // Polygon must be a closed loop
        if (openingCoordinates[0] !== closingCoordinates[0] ||
            openingCoordinates[1] !== closingCoordinates[1]) {
            return false;
        }
        const allCoordinatesAreValid = coordinatesCollection.every(CoordinatesPair_1.isCoordinatePairValid);
        return allCoordinatesAreValid;
    }
    defaultMessage() {
        return "Invalid Geo JSON Polygon format.";
    }
};
exports.IsGeoJsonGeofenceCoordinates = IsGeoJsonGeofenceCoordinates;
exports.IsGeoJsonGeofenceCoordinates = IsGeoJsonGeofenceCoordinates = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is Geo Json Polygon Coordinates" })
], IsGeoJsonGeofenceCoordinates);
//# sourceMappingURL=IsGeoJsonGeofenceCoordinates.js.map